import { UiSchema } from '@rjsf/utils'

import { FormProperties } from '../imup/types'

export const uiSchema: UiSchema = {
    'ui:order': ['material', 'glulam_type', 'ewp_width', 'width_other', 'height', 'height_other'],
    material: {
        'ui:title': 'Ledger Material',
        'ui:placeholder': 'Select Ledger Material',
    },
    glulam_type: {
        'ui:placeholder': 'Select Glulam Type',
    },
    type: {
        'ui:title': 'Ledger Type',
        'ui:placeholder': 'Select Type',
    },
    plies: {
        'ui:title': 'Plies',
        'ui:placeholder': 'Select Plies',
    },
    ewp_width: {
        'ui:title': 'Width',
        'ui:placeholder': 'Select Width',
    },
    width_other: {
        'ui:title': 'Other Width',
        'ui:placeholder': 'Enter Width in inches',
    },
    height: {
        'ui:title': 'Height',
        'ui:placeholder': 'Select Height',
    },
    height_other: {
        'ui:title': 'Other Height',
        'ui:placeholder': 'Enter Height in inches',
    },
    is_treated: {
        'ui:title': 'Treated',
        'ui:field': 'RadioButtons',
        'ui:options': {
            inline: true,
        },
    },
}

const onValidate = () => {}

const onSubmit = (settings, formData) => {
    const newSettings = { ...settings, ...formData }

    if (newSettings.material !== 'DIMENSIONAL LUMBER') {
        newSettings.thickness = null
        newSettings.width = null
    }
    // NOT one of these 'GL', 'LSL', 'LVL', 'PSL'
    if (!['GL', 'LSL', 'LVL', 'PSL'].includes(newSettings.material)) {
        newSettings.ewp_width = null
        newSettings.height = null
        newSettings.width_other = null
        newSettings.height_other = null
    } else {
        // For EWP materials (GL, LSL, LVL, PSL), transform 'other' values to numeric values for backend
        if (newSettings.width_other) {
            newSettings.ewp_width = newSettings.width_other
        }
        if (newSettings.height_other) {
            newSettings.height = newSettings.height_other
        }
    }

    if (newSettings.material !== 'GL') {
        newSettings.glulam_type = null
    }

    return newSettings
}

const form: FormProperties = { uiSchema, onValidate, onSubmit }

export default form
